import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import useStore from "../../../useStore";
import { useAuthentication } from "../../../Hooks/useAuthentication";
import Loader from "../../Elements/Loader/Loader";
import AdminMenu from "./AdminMenu";
import AdminPromos from "./AdminPromos";
import "./admin.css";

const LOGO = "/assets/imgs/logo-sin-fondo.webp";
const TAB_KEY = "pp_admin_tab";

const leerTab = () => {
  try {
    return localStorage.getItem(TAB_KEY) || "menu";
  } catch {
    return "menu";
  }
};

const Admin = () => {
  const { token, removeToken } = useAuthentication();
  const {
    fetchDataMenuAdmin,
    loadingMenuAdmin,
    errorMenuAdmin,
    secciones,
    productos,
    promos,
  } = useStore();
  const [tab, setTab] = useState(leerTab);

  let nombre = "";
  try {
    const decoded = jwtDecode(token);
    nombre = decoded.nombre || decoded.email || "";
  } catch { }

  useEffect(() => {
    fetchDataMenuAdmin();
  }, [fetchDataMenuAdmin]);

  const cambiarTab = (t) => {
    setTab(t);
    try {
      localStorage.setItem(TAB_KEY, t);
    } catch { }
  };

  const salir = () => {
    removeToken();
    window.dispatchEvent(new Event("authChange"));
  };

  const sinApi = !process.env.REACT_APP_BASE_URL;
  const cargandoPrimeraVez = loadingMenuAdmin && !secciones.length;

  return (
    <div className="pp-admin">
      <header className="pp-admin-header">
        <div className="pp-admin-header-inner">
          <a href="/" className="pp-admin-brand" title="Ver la página">
            <img src={LOGO} alt="Pizza Planeta" />
          </a>
          <div className="pp-admin-titulo">
            <span>Panel</span>
            {nombre && <small>Hola, {nombre} 👋</small>}
          </div>
          <div className="pp-admin-header-acciones">
            <a href="/" target="_blank" rel="noreferrer" className="pp-admin-link">
              <i className="bi bi-box-arrow-up-right" /> <span>Ver página</span>
            </a>
            <button type="button" className="pp-admin-link" onClick={salir}>
              <i className="bi bi-power" /> <span>Salir</span>
            </button>
          </div>
        </div>

        <nav className="pp-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={tab === "menu"}
            className={`pp-tab ${tab === "menu" ? "activo" : ""}`}
            onClick={() => cambiarTab("menu")}
          >
            <i className="bi bi-journal-text" /> Menú
            <span className="pp-tab-conteo">{productos.length}</span>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === "promos"}
            className={`pp-tab ${tab === "promos" ? "activo" : ""}`}
            onClick={() => cambiarTab("promos")}
          >
            <i className="bi bi-fire" /> Promos
            <span className="pp-tab-conteo">{promos.length}</span>
          </button>
        </nav>
      </header>

      <main className="pp-admin-main">
        {sinApi && (
          <div className="pp-aviso">
            <i className="bi bi-plug" />
            Falta configurar <code>REACT_APP_BASE_URL</code> con la URL de la Lambda. Sin eso el panel no puede leer ni guardar.
          </div>
        )}

        {cargandoPrimeraVez && <Loader fullscreen={false} showBackdrop={false} message="Cargando el menú…" />}

        {errorMenuAdmin && !loadingMenuAdmin && (
          <div className="pp-aviso pp-aviso-error">
            <i className="bi bi-exclamation-triangle" />
            {errorMenuAdmin}
            <button type="button" onClick={fetchDataMenuAdmin}>Reintentar</button>
          </div>
        )}

        {!cargandoPrimeraVez && (tab === "menu" ? <AdminMenu /> : <AdminPromos />)}
      </main>
    </div>
  );
};

export default Admin;
